import React, { useEffect } from 'react';

import Text from 'components/Text/Text';

export interface ServerErrorProps {}

const defaultProps: Partial<ServerErrorProps> = {};

const ServerError: React.FunctionComponent<ServerErrorProps> = () => {
  useEffect(() => {
    console.info('500 - Server error');
  });

  return (
    <div
      style={{
        margin: '16px',
        height: '100svh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <div>
        <Text size="heading1" text="Something went wrong" />
      </div>
    </div>
  );
};

ServerError.defaultProps = defaultProps;

export default ServerError;
